const STORAGE_KEY_PREFIX = "datatable_pagesize_";
const COLORING_STORAGE_KEY_PREFIX = "datatable_coloring_";

export const getStoredPageSize = (dataTableId, defaultValue = 15) => {
  if (!dataTableId) return defaultValue;
  try {
    const stored = localStorage.getItem(`${STORAGE_KEY_PREFIX}${dataTableId}`);
    return stored ? parseInt(stored, 10) : defaultValue;
  } catch (e) {
    console.warn("Error reading from localStorage", e);
    return defaultValue;
  }
};

export const setStoredPageSize = (dataTableId, size) => {
  if (!dataTableId) return;
  try {
    localStorage.setItem(`${STORAGE_KEY_PREFIX}${dataTableId}`, size.toString());
  } catch (e) {
    console.warn("Error writing to localStorage", e);
  }
};

export const getStoredRowColoring = (dataTableId, defaultValue = "none") => {
    if (!dataTableId) return defaultValue;
    try {
        const stored = localStorage.getItem(`${COLORING_STORAGE_KEY_PREFIX}${dataTableId}`);
        return stored ? stored : defaultValue;
    } catch (e) {
        console.warn("Error reading from localStorage", e);
        return defaultValue;
    }
};

export const setStoredRowColoring = (dataTableId, coloring) => {
    if (!dataTableId) return;
    try {
        localStorage.setItem(`${COLORING_STORAGE_KEY_PREFIX}${dataTableId}`, coloring);
    } catch (e) {
        console.warn("Error writing to localStorage", e);
    }
};
